import "@/App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";

const Register = lazy(() => import("@/pages/Register"));
const Admin = lazy(() => import("@/pages/Admin"));

const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

function CalculatorPage() {
  useDocumentTitle("Operational Overhead Calculator — Glydelabs.co");
  return <Calculator />;
}

function AdminPage() {
  useDocumentTitle("Admin — Glydelabs.co");
  return <Admin />;
}

const pageFallback = <div className="min-h-screen" />;

export function AppRoutes() {
  return (
    <Layout>
      <Suspense fallback={pageFallback}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/calculator" element={<CalculatorPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
